import { Component } from '@angular/core';

@Component({
  selector: 'app-contactperson',
  templateUrl: './contactperson.component.html',
  standalone: false,
})
export class ContactpersonComponent {}
